<div class="bg-gray-50 min-h-screen">
  <!-- Loader -->
  <app-loader *ngIf="loaderService.isLoading$ | async"></app-loader>

  <!-- Sidebar (desktop only) -->
  <div class="hidden xl:block w-64 bg-white shadow-sm border-r border-gray-200 fixed h-full z-40">
    <app-sidebar (linkClick)="closeSidebar()"></app-sidebar>
  </div>

  <!-- Header -->
  <app-header></app-header>

  <!-- Page Content -->
  <main class="xl:ml-64 p-3 sm:p-6 pt-16 sm:pt-20 pb-20 xl:pb-6" @routeAnimation>
    <router-outlet></router-outlet>
  </main>

  <!-- Bottom Navigation (mobile only) -->
  <app-bottom-nav></app-bottom-nav>

  <!-- Toast Notifications -->
  <app-toast></app-toast>
</div>
